// constants
import { ENTITIES } from 'constants/index'
// utils
import find from 'lodash/fp/find'
import pipe from 'lodash/fp/pipe'
import { safeGetOr } from 'utils/fp'

const isDescendant = (older, younger) => {
  return (
    !!older.children &&
    typeof older.children !== 'function' &&
    older.children.some(child => child === younger || isDescendant(child, younger))
  )
}

const getEntityTypeDescription = entityType => {
  if (entityType === ENTITIES.PLAN_ACTION) {
    return 'planAction'
  }

  if (entityType === ENTITIES.PLAN_OBJECTIVE) {
    return 'planObjective'
  }

  if (entityType === ENTITIES.PLAN_KPI) {
    return 'planKPI'
  }
}

const getEntityPath = entity => {
  if (!entity) {
    return
  }

  return pipe(
    safeGetOr([], 'planItems.data'),
    find(planItem => !planItem.referenced),
    planItem => {
      const plan = safeGetOr('', 'plan.name')(planItem)
      const path = safeGetOr([], 'path')(planItem)

      return `${plan} ${path.length ? '>' : ''} ${path.join(' > ')}`
    }
  )(entity)
}

export { getEntityTypeDescription, getEntityPath, isDescendant }
